import { TransportEquipmentType } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { excludeDeleted } from 'shared/lib/common-util'
import { CreateOrUpdateTransportEquipmentRequest, TransportEquipmentResponse } from 'api/models'

export function toCreateOrUpdateTransportEquipmentRequest(
  equipment: TransportEquipmentType,
  index: number,
): CreateOrUpdateTransportEquipmentRequest {
  return {
    id: equipment.id,
    sequenceNumber: index,
    containerIdentificationNumber: equipment.containerIdentificationNumber,
    containerSizeAndType: equipment.containerSizeAndType,
    packedStatus: equipment.packedStatus,
    supplierType: equipment.supplierType,
    seals: equipment.seals
      .filter((item) => !item.deleted)
      .map((sealItem, sealIndex) => ({
        id: sealItem.id,
        sequenceNumber: sealIndex,
        identifier: sealItem.identifier,
      })),
    goodsReferences: equipment.goodsReferences
      .filter(excludeDeleted)
      .map((goodsRefItem, goodsReferenceIndex) => ({
        id: goodsRefItem.id,
        sequenceNumber: goodsReferenceIndex,
        declarationGoodsItemNumber: goodsRefItem.declarationGoodsItemNumber,
        consignmentItemId: goodsRefItem.consignmentItemId,
      })),
  }
}

export function parseTransportEquipmentResponse(response: TransportEquipmentResponse, index: number): TransportEquipmentType {
  return {
    id: response.id,
    deleted: false,
    sequenceNumber: response?.sequenceNumber ?? index,
    containerIdentificationNumber: response.containerIdentificationNumber ?? '',
    containerSizeAndType: response.containerSizeAndType ?? '',
    packedStatus: response.packedStatus ?? '',
    supplierType: response.supplierType ?? '',
    goodsReferences: (response.goodsReferences ?? []).map((item, itemIndex) => ({
      id: item?.id,
      deleted: false,
      sequenceNumber: item?.sequenceNumber ?? itemIndex,
      declarationGoodsItemNumber: item?.declarationGoodsItemNumber ?? 0,
      consignmentItemId: item?.consignmentItemId ?? null,
    })),
    seals: response.seals.map((item, itemIndex) => ({
      id: item.id,
      deleted: false,
      identifier: item?.identifier ?? '',
      sequenceNumber: item?.sequenceNumber ?? itemIndex,
    })),
  }
}
